import React from 'react'
import { Link } from 'react-router-dom'

export default props => (

      <div className="user-panel">
        <div className="pull-left image">
          <img src={props.user_image || "dist/img/user.jpg"} className="img-circle" alt="foto do usuário" />
        </div>
        <div className="pull-left info">
          <p>{props.user_name || 'Anônimo'}</p>
          <Link to="/"><i className="fa fa-circle text-success"></i> {props.status || 'ativo'}</Link>
        </div>
      </div>

)